import React from "react";
import Section from "./../Section";
import SectionHeader from "./../SectionHeader";
import Testimonials from "./../Testimonials";
import "./styles.scss";

function TestimonialsSection(props) {
  return (
    <Section color={props.color} size={props.size}>
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          centered={true}
          size={3}
        />
        <Testimonials
          items={[
            {
              avatar:
                "https://ca.slack-edge.com/T025MV4TU-U027U0ZA6-db7d41cf49c5-128",
              name: "Helen Simonson",
              bio:
                "One thing I cannot do is crack is reducing my waste because everything is too hard, everything has packaging. I want to know how can we make it seem easy so I can do it and not feel guilty.",
              company: "EndGame"
            },
            {
              avatar:
                "https://ca.slack-edge.com/T025MV4TU-U1BEZEQJJ-6aad6a70b138-128",
              name: "Seth Corker",
              bio:
                "You have to start somewhere. A journey to zero-waste starts with recognizing you need to make a change. Take what I say with a grain of salt, I helped build 'Be Less Wasteful', so of course I'm going to say it's great!",
              company: "EndGame"
            },
            {
              avatar:
                "https://ca.slack-edge.com/T025MV4TU-U4CBVRCMC-c402926b6b7d-128",
              name: "Pearl Robin",
              bio:
                "As individuals we create 3,200 kilograms of waste each year. Everybody sees all the things about climate change and, you know, our grandchildren will be swimming in rubbish...What would the world look like if each individual was responsible for the waste we make?",
              company: "EndGame"
            }
          ]}
        />
      </div>
    </Section>
  );
}

export default TestimonialsSection;
